import { hasKey } from './has-key';
export const hasKeyValue = (
// eslint-disable-next-line @typescript-eslint/ban-types
rec, key, valueChecker) => 
// eslint-disable-next-line no-prototype-builtins
hasKey(rec, key) && valueChecker(rec[key]);
